module.exports = __webpack_public_path__ + "img/Snow.a59e196b.svg";